<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <h1>{{ fullname }}</h1>
      <div class="h1-subtitle text-center">
        {{ authorData.data.designation }}
      </div>

      <div
        class="flex md:flex-row flex-col md:mb-20 md:mt-16 justify-center items-center md:items-start mb-10"
      >
        <BaseAvatar
          :img="authorData.data.image"
          class="md:mr-11 w-[175px] md:my-0 my-10"
        ></BaseAvatar>
        <div class="flex flex-col max-w-[39rem] md:w-full md:mx-0 mx-4">
          <div class="grow-0 mb-4">
            <div class="text-blog-19 whitespace-pre-line">
              {{ authorData.data.short_info }}
            </div>
          </div>
          <div class="shrink-0 flex space-x-4 space-y-0">
            <a
              :href="authorData.data.linkedin"
              target="_blank"
              v-if="authorData.data.linkedin"
            >
              <img
                class="w-6 h-6"
                src="~assets/icons/linkedIn.svg"
                alt="linkedin"
            /></a>
          </div>
        </div>
      </div>

      <BlogPosts :author="authorData.data.id"> </BlogPosts>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();
defineI18nRoute({
  locales: ["en", "es"],
});
const { data: authorData, refresh: refreshAuthorData } =
  await useBlogAuthorSlug(route.params.slug);

const fullname = computed(() => {
  return (
    authorData.value.data.first_name + " " + authorData.value.data.last_name
  );
});

const breadcrumbs = getBreadcrumbs("blog-author-detail", authorData.value.data);
</script>
<style scoped>
.author-biography {
  white-space: pre-line;
}
</style>
